import React from 'react';
import styled from 'styled-components';
import { theme } from '../../../theme';
import { BodyText, Heading } from '../../typography';
import { SelectCardCheckbox } from './SelectCardCheckbox';
import { ButtonStyles } from './styles';

export type PrimarySelectCardProps = PrimarySelectCardOption & {
  onClick: (title: string) => void;
  selected?: boolean;
};

export type PrimarySelectCardOption = {
  title: string;
  subtitle: string;
  body: string;
};

const Button = styled.div`
  ${ButtonStyles}
  display: flex;
  justify-content: space-between;
  padding: ${theme.spacings[5].rem};
`;

const Content = styled.div`
  padding-right: ${theme.spacings[4].rem};
  word-break: break-word;
`;

const Title = styled(Heading)`
  margin-bottom: ${theme.spacings[1].rem};
`;

const SubTitle = styled(BodyText)`
  color: ${theme.colors.primary.graysGray};
  font-weight: 700;
  margin-bottom: ${theme.spacings[2].rem};
`;

const Checkbox = styled(SelectCardCheckbox)`
  flex: 0 0 32px;
  height: 32px;
`;

export const PrimarySelectCardButton: React.FC<PrimarySelectCardProps> = ({
  title,
  subtitle,
  body,
  onClick,
  selected = false,
  ...props
}) => (
  <Button onClick={() => onClick(title)} selected={selected} {...props}>
    <Content>
      <Title size={4}>{title}</Title>
      <SubTitle>{subtitle}</SubTitle>
      <BodyText>{body}</BodyText>
    </Content>
    <Checkbox checked={selected} />
  </Button>
);
